// extracted by mini-css-extract-plugin
module.exports = {"instructionDetailWrapper":"package-instruction-form_instructionDetailWrapper__3kbb1","triInput":"package-instruction-form_triInput__3ZoxG"};